<template>
  <div class="app">
    <router-view/>
  </div>
</template>

<script>
    export default {
        name: "app",
        components: {},
        data: function() {
            return {};
        }
    };
</script>

<style>
    html,
    body {
        width: 100%;
        height: 100%;
    }
    
     ::-webkit-scrollbar-track {
        background-color: #F9F9F9;
        width: 12px;
        height: 12px;
    }
    
     ::-webkit-scrollbar {
        width: 12px;
        height: 12px;
        background-color: #F9F9F9;
    }
    
     ::-webkit-scrollbar-thumb {
        width: 12px;
        height: 12px;
        background-color: #CBD6E3;
    }
    
    .app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        width: 100%;
        height: 100%;
    }
</style>